import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Capacitor } from '@capacitor/core';

@Injectable({ providedIn: 'root' })
export class GoogleMapsApiKeyService {
  getApiKey(): string {
    const platform = Capacitor.getPlatform();
    if (platform === 'android') {
      return environment.googleMapAPIKeyAndroid;
    }
    if (platform === 'ios') {
      return environment.googleMapAPIKeyIOS;
    }
    return environment.googleMapAPIKeyWeb;
  }

  /**
   * Build a Static Maps API URL for a display-only location map. Used instead
   * of an interactive google.maps.Map where no interaction is needed, to avoid
   * a billed dynamic map load on every render (#10476).
   *
   * `marker` defaults to true because every caller that passes a real position
   * wants the pin drawn on it. Pass false only for a map that is centred on a
   * meaningless point — a pin there would claim a location the record does not
   * have (#11028).
   */
  getStaticMapUrl(
    lat: number,
    lng: number,
    opts: { zoom?: number; size?: string; marker?: boolean } = {},
  ): string {
    const zoom = opts.zoom ?? 14;
    const size = opts.size ?? '600x300';
    const marker = opts.marker ?? true;
    const key = this.getApiKey();
    const markers = marker ? `&markers=color:red%7C${lat},${lng}` : '';
    return (
      `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}` +
      `&zoom=${zoom}&size=${size}&scale=2${markers}&key=${key}`
    );
  }
}
